<template>
	<el-container>
    <el-header height="80px">
      <div class="logo">
        <img src="../assets/logo.png" />
      </div>
    </el-header>
    <el-main>
      <el-row :gutter="20" :style="{'height': height}">
        <el-col :span="8" :offset="8">
          <div class="login">
            <h1 class="title">登录</h1>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
              <el-form-item label="学　校" prop="school_id">
                <el-select v-model="form.school_id"  placeholder="选择学校">
                  <el-option :label="item.name" v-for="item in school" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="form.mobile"></el-input>
              </el-form-item>
              <el-form-item label="密　码" prop="password">
                <el-input type="password" v-model="form.password"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code">
                <el-input v-model="form.code">
                  <template slot="suffix">
                    <img @click="getCaptcha()" class="captchas" v-if="captcha" :src="captcha.image" />
                  </template>
                </el-input>
              </el-form-item>
              
              <el-form-item>
                <el-button type="primary" @click="onSubmit('form')">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-main>
    <el-footer>
      <p class="footer">主办：安徽师大教育发展集团   运营：合肥百师优学教育咨询有限公司</p>
    </el-footer>
    </el-container>

</template>
<script>
  import { captcha as captchaApi, login as loginApi } from '../api/index'
  import { setToken } from '@/utils/auth'
  import { setUser } from '@/utils/user'
  import { index as indexApi } from '@/api/index'
  import { setCache } from '@/utils/cache'

	export default {
  name: 'Preview',
  data() {
    return {
      user: this.$store.state.user,
      height:'500px',
      form: {
        mobile: '',
        password: '',
        code: '',
        school_id: ''
      },
      rules: {
          school_id: [
            { required: true, message: '请选择学校', trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur' }
          ],
      },
      captcha: null,
      school: null
    }
  },
  props: {
    num: {
      default: 0
    },
    info: {
      default: function () {
        return []
      }
    }
  },
  watch: {
    info: function(newsData) {
      console.log(newsData)
      this.user = newsData
    }
  },
  created() {
    this.getConfig()
  },
  mounted() {
    this.height = (window.innerHeight - 180 ) + 'px'
    this.getCaptcha()
  },
  methods: {
    onSubmit(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form.captcha_token = this.captcha.token
            this.form.device_name = 'pc'
            loginApi(this.form).then(res=> {
              this.$message({
                message: '登录成功！',
                type: 'success',
                onClose: r => {
                  console.log(res)
                  setToken(res.token)
                  setUser(res.user)
                  this.$store.commit('SET_USER', res.user)
                  this.$router.push({name: 'Index'})
                }
              })
              
            })
          } else {
            console.log('error submit!!');
            return false;
          }
      });
    },
    getCaptcha(){
      captchaApi().then(res=> {
        this.captcha = res
        console.log(res)
      })
    },
    getConfig() {
      indexApi({}).then(res => {
        setCache('configs', res.config)
        setCache('index', res)
        this.school = res.school
      })
    }
  }

};

</script>
<style type="text/css" scoped>
.el-select{
  width: 100%;
}
.el-header, .el-footer {
    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
.el-main{
  background-color: #cfe2ff;
}

.login{
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-top: 20%;
}
.title{
  text-align: center;
  margin: 20px;
  color: #1680ff;
}
.captchas{
  border-radius: 2px;
  margin-top: 6px;
}
.footer{font-size: 16px; text-align: center;}
</style>